import { render, staticRenderFns } from "./DishTags.vue?vue&type=template&id=112b30dc&scoped=true&lang=pug"
import script from "./DishTags.vue?vue&type=script&lang=js"
export * from "./DishTags.vue?vue&type=script&lang=js"
import style0 from "./DishTags.vue?vue&type=style&index=0&id=112b30dc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112b30dc",
  null
  
)

export default component.exports